import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  requestDetailActivity,
  requestUpdateActivityEvent,
} from 'app/api/activityEvent'
import { IActivity } from 'app/api/activityEvent/model'
import { requestGetColumnActivity } from 'app/api/columns'
import { IColumn } from 'app/api/columns/model'
import { IEvent, TypeColumn, TypeEventEnum } from 'app/api/event/model'
import { SvgDeleteDesignIcon } from 'app/assets/svg-assets'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputNumber } from 'app/components/common/inputs/InputNumber'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { notificationController } from 'app/controllers/notification-controller'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { isEqual } from 'lodash'
import { BORDER_RADIUS, PADDING } from 'parkway-web-common'
import { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { IActivityEvent, IColumnActivity } from '../../../../CreateEvent/type'

export const UpdateActivityModal = ({
  id,
  event,
}: {
  id: number
  event?: IEvent
}) => {
  const [form] = BaseForm.useForm<IActivityEvent>()
  const [isLoading, setIsLoading] = useState(false)
  const [columns, setColumns] = useState<IColumnActivity[]>([])

  const modalRef = useRef<IRefModal>({})
  const openModal = () => {
    modalRef?.current?.open?.()
  }

  const getData = async () => {
    try {
      const [activity, columnsValue] = await Promise.all([
        requestDetailActivity(id),
        requestGetColumnActivity(id),
      ])
      if (activity?.data) {
        const value: IActivity = activity?.data
        form.setFieldsValue({
          title: value?.name,
          valueCare: value?.value_care,
          limitMember: value?.limit_member,
          limitTeam: value?.limit_member,
        })
      }

      if (columnsValue?.data) {
        const columnsData: IColumn[] = columnsValue?.data
        setColumns(
          columnsData?.map(column => ({
            ...column,
            keyOfMainData: column?.key_of_main_data,
            name: column?.name_column,
            type: column.type_value,
          } as IColumnActivity)),
        )
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [id])

  const handleSubmit = async (values: IActivityEvent) => {
    if (!id) return
    try {
      setIsLoading(true)
      const res = await requestUpdateActivityEvent({
        name: values?.title,
        limit_member: values?.limitMember,
        limit_team: values?.limitTeam,
        value_care: values?.valueCare,
        eventId: event?.id,
        id,
        columns,
      })

      if (res) {
        modalRef?.current?.hide?.()
        notificationController.success({ message: 'Thành công!' })
        window.location.reload()
        form?.resetFields?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoading(false)
    }
  }

  const onChangeNameColumn = (index: number, name: string) => {
    const newColumns = [...columns]
    newColumns[index].name = name
    setColumns(newColumns)
  }

  const onChangeTypeColumn = (index: number, type: TypeColumn) => {
    const newColumns = [...columns]
    newColumns[index].type = type
    setColumns(newColumns)
  }

  const onDeleteColumn = (index: number) => {
    const newColumns = [...columns]
    newColumns.splice(index, 1)
    setColumns(newColumns)
  }

  const addNewColumn = () => {
    setColumns([
      ...columns,
      {
        name: '',
        type: undefined,
      },
    ])
  }

  const disableSubmit = useMemo(() => {
    if (isEqual(TypeEventEnum.ACTIVITY, event?.type)) {
      if ( !columns?.length) return true
      return columns?.some(item => !item?.name || !item?.type)
    }
    return false

  }, [columns])

  return (
    <BaseModalComponent
      titleModal={'Cập nhật'}
      ref={modalRef}
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      isDisableSubmit={disableSubmit}
      buttonOpenModal={
        <BaseButton
          icon={<EditOutlined rev={undefined} />}
          onClick={openModal}
          type="text"
        />
      }
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace>
            <BaseFormItem
              name={'title'}
              required
              label={'Tên hoạt động'}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập tên hoạt động',
                },
              ]}
            >
              <BaseInput placeholder="Nhập tên hoạt động" />
            </BaseFormItem>

            {isEqual(event?.type, TypeEventEnum.CARE) ? (
              <BaseFormItem name={'valueCare'} label={'Phần quà chăm lo'}>
                <BaseInput placeholder="Nhập phần quà" />
              </BaseFormItem>
            ) : null}

            {(() => {
              switch (event?.type) {
                case TypeEventEnum.CARE:
                case TypeEventEnum.OTHER:
                case TypeEventEnum.TRAINING:
                case TypeEventEnum.SUPERIOR_GROUP:
                  return (
                    <BaseFormItem
                      name={'limitMember'}
                      label={'Giới hạn đăng ký'}
                    >
                      <InputNumber
                        placeholder="Nhập giới hạn đăng ký"
                        style={{ width: '100%' }}
                      />
                    </BaseFormItem>
                  )
                case TypeEventEnum.ACTIVITY:
                  return (
                    <>
                      {event?.isHaveTeam ? (
                        <BaseSpace
                          style={{
                            backgroundColor: convertedVariables.backgroundColor,
                            borderRadius: 8,
                          }}
                          size={4}
                        >
                          <BaseFormItem
                            name={'limitTeam'}
                            label={'Giới hạn đội đăng ký'}
                          >
                            <InputNumber
                              placeholder="Nhập giới hạn đội đăng ký"
                              style={{ width: '100%' }}
                            />
                          </BaseFormItem>

                          <BaseFormItem
                            name={'limitMember'}
                            label={'Giới hạn thành viên/đội'}
                          >
                            <InputNumber
                              placeholder="Nhập giới hạn thành viên/đội"
                              style={{ width: '100%' }}
                            />
                          </BaseFormItem>
                        </BaseSpace>
                      ) : (
                        <>
                          <BaseFormItem
                            name={'limitMember'}
                            label={'Giới hạn đăng ký'}
                          >
                            <InputNumber
                              placeholder="Nhập giới hạn đăng ký"
                              style={{ width: '100%' }}
                            />
                          </BaseFormItem>
                        </>
                      )}
                    </>
                  )
              }
            })()}

            {isEqual(TypeEventEnum.ACTIVITY, event?.type) ? (
              <BaseRow
                gutter={[16, 8]}
                align={'middle'}
                justify={'space-between'}
              >
                <BaseCol>
                  <BaseText
                    children={'Danh sách các cột dữ liệu'}
                    fontSize="xs"
                    fontWeight="semibold"
                  />
                </BaseCol>
                <BaseCol>
                  <BaseButton
                    icon={<PlusOutlined rev={undefined} />}
                    onClick={addNewColumn}
                  >
                    {'Thêm cột dữ liệu'}
                  </BaseButton>
                </BaseCol>
              </BaseRow>
            ) : null}

            {isEqual(TypeEventEnum.ACTIVITY, event?.type) ? (
              <ContentWrapper>
                <ValueWrapper size={8}>
                  {columns?.map((item, index) => {
                    return (
                      <BaseRow
                        key={index}
                        gutter={8}
                        wrap={false}
                        align={'middle'}
                        justify={'space-between'}
                      >
                        <BaseCol xl={10}>
                          <BaseFormItem hiddenLabel>
                            <BaseInput
                              value={item?.name}
                              onChange={e =>
                                onChangeNameColumn(index, e.target.value)
                              }
                              placeholder="Tên cột"
                              disabled={!!item?.keyOfMainData}
                            />
                          </BaseFormItem>
                        </BaseCol>
                        <BaseCol xl={10}>
                          <BaseFormItem hiddenLabel>
                            <BaseSelect
                              options={[
                                {
                                  value: TypeColumn.STRING,
                                  label: 'Chuỗi kí tự',
                                },
                                {
                                  value: TypeColumn.NUMBER,
                                  label: 'Số',
                                },
                                {
                                  value: TypeColumn.DATE,
                                  label: 'Ngày tháng',
                                },
                              ]}
                              value={item?.type}
                              placeholder="Chọn kiểu dữ liệu"
                              onChange={value =>
                                onChangeTypeColumn(index, value as TypeColumn)
                              }
                              disabled={!!item?.keyOfMainData}
                            />
                          </BaseFormItem>
                        </BaseCol>
                        <BaseCol xl={2}>
                          <BaseButton
                            icon={<SvgDeleteDesignIcon />}
                            onClick={() => onDeleteColumn(index)}
                            type="text"
                            disabled={!!item?.keyOfMainData}
                          />
                        </BaseCol>
                      </BaseRow>
                    )
                  })}
                </ValueWrapper>
              </ContentWrapper>
            ) : null}
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}

const ContentWrapper = styled(BaseSpace)`
  background-color: ${convertedVariables.neutralBlack9Color};
  padding: ${PADDING.xxs};
  border-radius: ${BORDER_RADIUS};
`

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px;
`

const ValueWrapper = styled(BaseSpace)`
  background-color: ${convertedVariables.backgroundColor};
  border-radius: ${BORDER_RADIUS};
  padding: ${PADDING.xxxs};
`
